<template>
  <div class="page-container">
    <div class="search-box">
      <el-select v-model="params.factory_id" placeholder="厂区" clearable style="width:170px" @change="loadData">
        <el-option v-for="f in factories" :key="f.id" :label="f.name" :value="f.id" />
      </el-select>
      <el-select v-model="params.range" placeholder="时间范围" style="width:150px" @change="loadData">
        <el-option label="近7天" value="7d" />
        <el-option label="近30天" value="30d" />
        <el-option label="本月" value="month" />
        <el-option label="本季度" value="quarter" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="loadData">查询</el-button>
      <span class="spacer" />
      <el-button v-if="hasPermission('report_export')" icon="el-icon-download" @click="exportCsv">导出 CSV</el-button>
    </div>

    <div class="rp-grid">
      <div class="rp-card">
        <div class="rp-title">设备在线率趋势（%）</div>
        <div ref="onlineChart" class="rp-chart"></div>
      </div>
      <div class="rp-card">
        <div class="rp-title">故障率趋势（%）</div>
        <div ref="faultChart" class="rp-chart"></div>
      </div>
      <div class="rp-card">
        <div class="rp-title">超速次数 TOP 设备</div>
        <div ref="overChart" class="rp-chart"></div>
      </div>
      <div class="rp-card">
        <div class="rp-title">作业量趋势</div>
        <div ref="workChart" class="rp-chart"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getReports, getFactories } from '@/api/sentinel'

export default {
  name: 'ReportIndex',
  data() {
    return {
      params: { factory_id: '', range: '7d' },
      factories: [],
      data: {},
      charts: []
    }
  },
  mounted() {
    getFactories().then(res => { if (res.code === 200) this.factories = (res.data && res.data.list) || [] })
    this.loadData()
    window.addEventListener('resize', this.resize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize)
    this.charts.forEach(c => c && c.dispose())
  },
  methods: {
    hasPermission(k) { return this.$store.getters.hasPermission(k) },
    loadData() {
      getReports(this.params).then(res => {
        if (res.code === 200 && res.data) {
          this.data = res.data
          this.$nextTick(this.renderCharts)
        }
      })
    },
    renderCharts() {
      const d = this.data
      this.charts = []
      this.charts.push(this.line('onlineChart', d.onlineTrend, '#165dff'))
      this.charts.push(this.bar('faultChart', d.faultRate, '#f53f3f'))
      this.charts.push(this.hbar('overChart', d.overspeedTop, '#ff7d00'))
      this.charts.push(this.line('workChart', d.workTrend, '#00b42a'))
    },
    line(refName, d, color) {
      const el = this.$refs[refName]
      if (!el || !d) return null
      const chart = this.$echarts.init(el)
      chart.setOption({
        tooltip: { trigger: 'axis' },
        grid: { left: 44, right: 18, top: 20, bottom: 30 },
        xAxis: { type: 'category', data: d.cats, axisLine: { lineStyle: { color: '#c9cdd4' } } },
        yAxis: { type: 'value' },
        series: [{ type: 'line', smooth: true, data: d.series, itemStyle: { color }, areaStyle: { color: color + '22' } }]
      })
      return chart
    },
    bar(refName, d, color) {
      const el = this.$refs[refName]
      if (!el || !d) return null
      const chart = this.$echarts.init(el)
      chart.setOption({
        tooltip: { trigger: 'axis' },
        grid: { left: 44, right: 18, top: 20, bottom: 30 },
        xAxis: { type: 'category', data: d.cats, axisLine: { lineStyle: { color: '#c9cdd4' } } },
        yAxis: { type: 'value' },
        series: [{ type: 'bar', data: d.series, itemStyle: { color }, barWidth: '46%' }]
      })
      return chart
    },
    hbar(refName, list, color) {
      const el = this.$refs[refName]
      if (!el || !list) return null
      const chart = this.$echarts.init(el)
      chart.setOption({
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
        grid: { left: 120, right: 24, top: 10, bottom: 20 },
        xAxis: { type: 'value' },
        yAxis: { type: 'category', data: list.map(x => x.name).reverse(), axisLabel: { color: '#4e5969' } },
        series: [{ type: 'bar', data: list.map(x => x.count).reverse(), itemStyle: { color }, barWidth: '56%' }]
      })
      return chart
    },
    exportCsv() {
      const d = this.data
      const rows = [['报表类型', '维度', '数值']]
      if (d.onlineTrend) d.onlineTrend.cats.forEach((c, i) => rows.push(['在线率', c, d.onlineTrend.series[i]]))
      if (d.faultRate) d.faultRate.cats.forEach((c, i) => rows.push(['故障率', c, d.faultRate.series[i]]))
      if (d.overspeedTop) d.overspeedTop.forEach(x => rows.push(['超速TOP', x.name, x.count]))
      if (d.workTrend) d.workTrend.cats.forEach((c, i) => rows.push(['作业量', c, d.workTrend.series[i]]))
      const csv = '﻿' + rows.map(r => r.join(',')).join('\n')
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = 'sentinel-report.csv'
      a.click()
      URL.revokeObjectURL(url)
      this.$message.success('报表已导出')
    },
    resize() { this.charts.forEach(c => c && c.resize()) }
  }
}
</script>

<style scoped>
.search-box { display: flex; align-items: center; gap: 12px; margin-bottom: 16px; flex-wrap: wrap; }
.search-box .spacer { flex: 1; }
.rp-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
.rp-card { background: #fff; border-radius: 4px; box-shadow: 0 2px 12px rgba(0,0,0,.1); padding: 16px; }
.rp-title { font-size: 15px; font-weight: 600; color: #1d2129; margin-bottom: 12px; }
.rp-chart { width: 100%; height: 300px; }
@media (max-width: 900px) { .rp-grid { grid-template-columns: 1fr; } }
</style>
